import ProtectedLayout from "./ProtectedLayout";
import ProtectedRoute from "../Routes/ProtectedRoute";
import GlobalApiRefetcher from "../../GlobalApiRefetcher";
import { SocketProvider } from "../../context/SocketContext";

const ProtectedPageLayout = ({ children, ...layoutProps }) => {
  return (
    <ProtectedRoute>
      <SocketProvider>
        <GlobalApiRefetcher />
        <ProtectedLayout {...layoutProps}>{children}</ProtectedLayout>
      </SocketProvider>
    </ProtectedRoute>
  );
};

export default ProtectedPageLayout;
